import styled from '@emotion/styled';

export const DescriptionBody = styled.div`
  ${({ theme }) => `
    white-space: pre-line;
    padding-bottom: ${theme.spacing(1)};

    h1, h2, h3, h4, h5 {
      padding: 0 0 ${theme.spacing(1)};
      display: inline-block;
      width: 100%;
    }

    p, div {
      padding: 0 0 ${theme.spacing(1)};
    }

    center {
      padding: 0 0 ${theme.spacing(1)};
      display: block;
      text-align: center;
    }

    ul,
    ol {
      padding: ${theme.spacing(1)} 14px ${theme.spacing(1)} 0;
      margin: 0 0 0 ${theme.spacing(2)};
      display: inline-block;
      white-space: normal;
      li {
        margin: ${theme.spacing(0.5)} 0;
      }
    }

    ul {
      li {
        list-style-type: circle;
      }
    }

    ol {
      li {
        list-style-type: decimal;
      }
    }

    u {
      text-decoration: underline;
    }

    b, strong {
      font-weight: 700;
    }
  `}
`;

export const DescriptionReadMore = styled.span`
  display: inline;
  padding-right: ${({ theme }) => theme.spacing(0.5)};
  cursor: pointer;
`;
